import React from 'react'
import Image from './Image';
import ProfileInitial from 'atoms/ProfileInitial';

function UserProfile({ name, src, width = 62, height = 62, layout = '', fontSize, objectFit = 'cover', alt = 'profile' }) {
    return (
        src ? (
            <Image
                src={src}
                layout={layout}
                objectFit={objectFit}
                alt={alt}
                {...(!layout ? { width, height } : {})}
            />
        ) : (
            <ProfileInitial
                name={name}
                width={layout === 'fill' ? '100%' : width}
                height={layout === 'fill' ? '100%' : height}
                fontSize={fontSize}
            />
        )
    )
}

export default UserProfile;
